<template>
  <p>Brīva vieta Jūsu reklāmai</p>
</template>

<script setup>
</script>